import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';

const moduleFn = () => import('feature/admin/admin-module');

export default function AdminLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/admin/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'admin',
        instanceKey: 'one',
        moduleFn,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
